import {
  MarkdownEditor as MarkdownEditorBase,
  type MarkdownToolbarOptions,
  ViewMode,
} from '@efdigital/ll-addon-codemirror';
import type {
  ImagePickerCallback,
  ImagePickerData,
} from '@efdigital/ll-addon-codemirror/lib/codemirror/image-picker';
import type { Status } from '@efdigital/ll-addon-codemirror/lib/codemirror/status';
import type { MediaImage } from '@efdigital/ll-addon-data/types/content/media-image';
import { type ImageContent } from '@efdigital/ll-admin-v2/lib/media/sizes';
import { fn } from '@ember/helper';
import Component from '@glimmer/component';

import type { MediaImageSizeType } from '../lib/media/models.ts';
import { ImagePickerModal } from './pickers/image-picker/image-picker-modal.gts';

export class MarkdownEditorWithImagePicker extends Component<{
  Args: {
    markdown: string;
    toolbar: MarkdownToolbarOptions;
    onUpdate: (value: string) => void;
    mode?: ViewMode;
    requiredSize: MediaImageSizeType | 'original';
  };
  Blocks: {
    toolbar?: [status: Status, mode: ViewMode];
  };
  Element: HTMLDivElement;
}> {
  imagePickerCallback: ImagePickerCallback | null = null;

  prepareImagePicker = (
    showModal: () => void,
    _data: ImagePickerData,
    callback: ImagePickerCallback
  ) => {
    this.imagePickerCallback = callback;
    showModal();
    return true;
  };

  imageSelected = (image: ImageContent | null, mediaImage?: MediaImage) => {
    if (this.imagePickerCallback && image) {
      this.imagePickerCallback({
        alt: mediaImage?.alt || '',
        src: image?.url || '',
      });
    }
  };

  <template>
    <ImagePickerModal
      @requiredSize={{@requiredSize}}
      @onSelectImage={{this.imageSelected}}
    >
      <:input as |showModal|>
        <MarkdownEditorBase
          @markdown={{@markdown}}
          @toolbar={{@toolbar}}
          @mode={{@mode}}
          @onUpdate={{@onUpdate}}
          @imagePicker={{fn this.prepareImagePicker showModal}}
        >
          <:preview as |markdown|>
            <pre>{{markdown}}</pre>
          </:preview>
        </MarkdownEditorBase>
      </:input>
    </ImagePickerModal>
  </template>
}
